import React, { memo } from 'react';

const BigNewBornChild = memo(({ size = 56 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 57 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.9333 4.66666H26.2666C18.5346 4.66666 12.2666 10.9347 12.2666 18.6667V37.3333C12.2666 45.0653 18.5346 51.3333 26.2666 51.3333H30.9333C38.6653 51.3333 44.9333 45.0653 44.9333 37.3333V18.6667C44.9333 10.9347 38.6653 4.66666 30.9333 4.66666Z"
        stroke="#5A1AB3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.9337 25.6667C44.9337 25.6667 33.9437 39.9233 12.8037 39.9233"
        stroke="#5A1AB3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2666 25.2933C12.2666 25.2933 17.0966 32.9 27.9233 37.2867"
        stroke="#5A1AB3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.5774 26.32C32.6496 26.32 35.9508 22.8935 35.9508 18.6667C35.9508 14.4398 32.6496 11.0133 28.5774 11.0133C24.5053 11.0133 21.2041 14.4398 21.2041 18.6667C21.2041 22.8935 24.5053 26.32 28.5774 26.32Z"
        stroke="#5A1AB3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.707 31.15C19.5704 28.1867 21.297 25.76 23.5137 24.2667"
        stroke="#5A1AB3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.4007 30.8933C37.5141 28.0467 35.8107 25.69 33.6641 24.2433"
        stroke="#5A1AB3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

export default BigNewBornChild;
